// проверка СНИЛС
export function isSnilsValid(gps){
  gps = String(gps).replace(/[^0-9]+/g, '');
  if( gps.length == 11 ) {
    var checksum = 0;
    for( var i = 0; i < 9; i++ ) {
      checksum += parseInt(gps.charAt(i)) * (9 - i);
    }
    if( checksum > 101 ) {
      checksum = checksum % 101;
    }
    if( checksum == 100 || checksum == 101 ) {
      checksum = 0;
    }
    return checksum == parseInt(gps.substr(9));
  }
  return false;
}

export function isHTML(text) {
  var a = document.createElement("div");
  a.innerHTML = text;

  for (var c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType == 1) {
      return true;
    }
  }

  return false;
}

/**
 * dd.mm.yyyy или yyyy.mm.dd
 *
 * @param {*} text
 * @returns {Date|false}
 */
export function isDate(text) {
  if (!text) {
    return false;
  }

  let [d, m, y] = [0, 0, 0];

  if (text.match(/(\d{2})\.(\d{2})\.(\d{4})/)) {
    [d, m, y] = text.split(".");
  } else if (text.match(/(\d{4})\.(\d{2})\.(\d{2})/)) {
    [y, m, d] = text.split(".");
  } else {
    return false;
  }

  let t = new Date([y, m, d].join("."));
  if (t != "Invalid Date") {
    return t;
  }

  return false;
}

export function isURL(str) {
  let url;

  try {
    url = new URL(str);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

export function isJSON(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}